import { gsap, ScrollTrigger } from '../LibrariesImport';
import { GlobalVariables } from '../GlobalVariables';

export default class BlockPeople {
	static init() {
		this.blocks = document.querySelectorAll(".block-people");
		if (!this.blocks) {
			return;
		}

		this.mm = gsap.matchMedia();

		this.initSlider();
	}

	static initHorizontalScroll() {
		// Horizontal Scroll logic here if needed
	}

	static resize() {
		this.blocks.forEach((block) => {
			const pinWrap = block.querySelector('.person-container');
			const blockPadding = parseFloat(getComputedStyle(block).getPropertyValue('padding-right'));

			this.pinWrapWidth = pinWrap.scrollWidth + blockPadding;
			this.horizontalScrollLength = this.pinWrapWidth + blockPadding - innerWidth;
		});
	}

	static initSlider() {
		this.blocks.forEach((block) => {
			const swiperContainer = block.querySelector('.person-container');
			const scrollbar = block.querySelector('.person-progress');

			const slider = new Swiper(swiperContainer, {
				loop: false,
				grabCursor: true,
				slidesPerView: 1,
				spaceBetween: 10,
				scrollbar: {
					el: scrollbar,
					draggable: true,
					snapOnRelease: false,
				},
				mousewheel: {
					enabled: true,
					releaseOnEdges: true,
					forceToAxis: true,
				},
				breakpoints: {
					576: {
						slidesPerView: 1,
					},
					768: {
						slidesPerView: 2,
					},
					992: {
						slidesPerView: 3,
					},
					1920: {
						slidesPerView: 4,
					},

				},
				slideClass: 'person-slide',
				on: {
					lock: () => {
						swiperContainer.classList.remove('swiper-is-active');
					},
					unlock: () => {
						swiperContainer.classList.add('swiper-is-active');
					},
					resize: (swiper) => {
						swiperContainer.classList.toggle('hidden', swiper.isEnd);
					},
				},
			});
		});
	}
}
